<template>
  <div>
    <v-dialog
      v-model="show"
      persistent
      width="950px"
      min-height="60%"
      scrollable
    >
      <v-card>
        <v-card-title class="pa-3">
          Attach Image
          <v-spacer />
          <v-btn
            icon
            color="error"
            @click="close()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-app-bar
          dense
          flat
        >
          <v-row align="center">
            <v-col cols="4">
              <v-text-field
                id="account_search_printer_template"
                v-model.trim="searchText"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                clearable
                outlined
                hide-details
                dense
                @input="search()"
              />
            </v-col>
            <v-spacer />
            <v-col
              cols="5"
              class="text-right"
            />
          </v-row>
        </v-app-bar>
        <v-divider />
        <v-card-text
          class="pa-4"
          style="min-height:350px;"
        >
          <v-row
            v-show="totalPage == 0"
            class="py-4 px-1"
          >
            no images found
          </v-row>
          <v-row v-show="totalPage != 0">
            <v-col
              v-for="image in images"
              :key="image.id"
              class="d-flex child-flex"
              cols="12"
              md="4"
              lg="3"
            >
              <v-card
                style="position:relative"
                @click="setSelectedImg(image.id)"
              >
                <div
                  v-if="selectedImgId && selectedImgId === image.id"
                  class="overlay-selected"
                />
                <v-img
                  :src="`${baseURL}/${image.id}?v=${image.version}`"
                  aspect-ratio="1"
                  contain
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      />
                    </v-row>
                  </template>
                </v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            outlined
            color="success"
            :disabled="!selectedImgId"
            @click="updateImg()"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
    name: "ImageConfig",
    props: {
        showImageConfig: { type: Boolean, default: false, required: true }
    },
    data() {
        return {
            searchText: null,
            page: 1,
            loader: false,
            images: [],
            totalPage: 0,
            baseURL: `${this.IMAGE_SERVER_API_URL}/images`,
            accountID: 0,
            selectedImgId: null
        };
    },
    computed: {
        show() {
            return this.showImageConfig || false;
        }
    },
    watch: {
        show(v) {
            if (v) {
                console.log({v});
                this.init();
            }
        }
    },
    methods: {
        getImages() {
            this.loader = true;
            let url = `${this.IMAGE_SERVER_API_URL}/accounts/${this.accountID}/images?page=${this
                .page - 1}&sort_key=tags`;
            if (this.searchText) {
                url += `&search=${this.searchText}`;
            }

            this.$http.get(url).then(
                (res) => {
                    this.images = res.body.data || [];
                    this.totalPage = res.body.totalPage;
                    this.page = res.body.pagination.page + 1;
                    this.loader = false;
                },
                (failure) => {
                    this.handleFailure(failure);
                    this.loader = false;
                }
            );
        },
        setSelectedImg(imgID) {
            this.selectedImgId = imgID;
        },
        search() {
            if (this.searchText && this.searchText.length < 3) {
                return;
            }
            this.page = 1;
            this.getImages();
        },
        updateImg(){
            if (!this.selectedImgId) return;
            this.$emit("attachImg", this.selectedImgId);
            setTimeout(()=>{
                this.selectedImgId = null;
                this.close();
            }, 100);
        },
        close() {
            this.$emit("update:showImageConfig", false);
        },
        init() {
            this.selectedImgId = null;
            console.log("Init Image config");
            this.accountID = JSON.parse(localStorage.getItem("account_info")).id;
            this.searchText = null;
            this.search();
        }
    }
};
</script>

<style>
.overlay-selected {
    background: #ee44aa;
    opacity: .5;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 9;
}

</style>